__turbopack_context__.v({
  "cardsWrapper": "Membership-module-scss-module__ii32kG__cardsWrapper",
  "everyPlanDetailText": "Membership-module-scss-module__ii32kG__everyPlanDetailText",
  "wrapper": "Membership-module-scss-module__ii32kG__wrapper",
});
